/*
 * @author:
 * @Date: 2021-10-22 15:20:00
 * @LastEditTime: 2022-12-06 09:22:05
 * @FilePath: \场外----客户\src\router\index.js
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import vailableRoutes from '@/router/routes.js'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/Login.vue')
  },
  {
    path: '/tradeCustLogin',
    name: 'LoginPage',
    component: () => import('@/views/login/LoginPage.vue')
  },
  {
    path: '/managerlogin',
    name: 'ManagerLogin',
    component: () => import('@/views/login/ManagerLogin.vue')
  },
  {
    path: '/loginEntry',
    name: 'LoginEntry',
    component: () => import('@/views/login/LoginEntry.vue')
  },
  {
    path: '/stockConfirmInput',
    name: 'StockConfirmInput',
    component: () => import('@/views/stockAutomaticOrder/StockConfirmInput.vue')
  },
  {
    path: '/stockConfirmSubmit',
    name: 'StockConfirmSubmit',
    component: () =>
      import('@/views/stockAutomaticOrder/StockConfirmSubmit.vue')
  }
]

const createRouter = () =>
  new VueRouter({
    routes
  })

const router = createRouter()
router.addRoutes(vailableRoutes)

export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
